import { render, staticRenderFns } from "./PrestationSubcategoryForm.vue?vue&type=template&id=104e7960"
import script from "./PrestationSubcategoryForm.vue?vue&type=script&lang=js"
export * from "./PrestationSubcategoryForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports